<script type="ts">
  import type { Dropdown } from "../lib/interfaces";
  import fetchAudiences from '../lib/fetchAudiences';
  import fetchSolutions from '../lib/fetchSolutions';
  import fetchIndustries from '../lib/fetchIndustries';
  import fetchProducts from '../lib/fetchProducts';
  import ProductCard from "./ProductCard.svelte";
  import { fade } from "svelte/transition";
  import { onMount } from "svelte";

  import {
    selectedAudience,
    selectedSolution,
    selectedChildIndustry,
  } from "../stores";

  export let dropdown: Dropdown;

  let industries = [];
  let audiences = [];
  let solutions = [];
  let products = [];
  const fadeParams = {
    duration: 250
  };

  onMount(() => {

    fetchAudiences().then((result) => {
      audiences = result;
    });

    fetchIndustries().then((result) => {
      industries = result;
    });

  });

  const StepOneTitle = dropdown.template_3.step1;
  const StepTwoTitle = dropdown.template_3.step2;
  const StepThreeTitle = dropdown.template_3.step3;
  const StepFourTitle = dropdown.template_3.step4;

  let audienceActive = null;
  let solutionActive = null;
  let industryActive = null;

  function clearActive(element)
  {
    const parent = element.parentElement;
    const activeChilds = parent.querySelectorAll('.active');
    activeChilds.forEach(child => {
      child.classList.remove('active');
    });
  }

  function assignAudience(event)
  {
    const customEventData = event.target;
    audienceActive = true;
    $selectedChildIndustry = '';
    $selectedAudience = '';
    $selectedSolution = '';


    if (customEventData.classList.contains('dropdown-three__toggle')) {
      $selectedAudience = customEventData.dataset.value;
      clearActive(customEventData);
      customEventData.classList.add('active');

    } else {
      $selectedAudience = customEventData.parentElement.dataset.value;
      clearActive(customEventData.parentElement);
      customEventData.parentElement.classList.add('active');
    }

  }

  function assignSolution(event)
  {
    const customEventData = event.target;
    solutionActive = true;
    $selectedSolution = '';


    if (customEventData.classList.contains('dropdown-three__toggle')) {
      $selectedSolution = customEventData.dataset.value;
      clearActive(customEventData);
      customEventData.classList.add('active');

    } else {
      $selectedSolution = customEventData.parentElement.dataset.value;
      clearActive(customEventData.parentElement);
      customEventData.parentElement.classList.add('active');

    }
  }

  function assignIndustry(event)
  {
    const customEventData = event.target;
    industryActive = true;
    $selectedChildIndustry = '';
    $selectedSolution = '';

    if (customEventData.classList.contains('dropdown-three__toggle')) {
      $selectedChildIndustry = customEventData.dataset.value;
      clearActive(customEventData);
      customEventData.classList.add('active');
    } else {
      $selectedChildIndustry = customEventData.parentElement.dataset.value;
      clearActive(customEventData.parentElement);
      customEventData.parentElement.classList.add('active');
    }
  }

</script>

<div class="dropdown-three">
  <div class="dropdown-three__wrapper">

    <div class="dropdown-three__step" class:closed={$selectedAudience}>
      {#if StepOneTitle}
        <span class="dropdown-three__heading">{StepOneTitle}</span>
      {/if}

      <div class="dropdown-three__toggle-wrapper">
        {#each audiences as audience}
        {@const AudienceData = audience.acf}
          <button transition:fade={fadeParams} class="dropdown-three__toggle" data-value={audience.audience.term_id} on:click|stopPropagation={(event) => assignAudience(event)}>
          {#if AudienceData != null}
            <img class="dropdown-three__image" src={AudienceData.url} alt="{AudienceData.title}" />
          {/if}
          <span class="dropdown-three__first-toggle-title">{@html audience.audience.name}</span>
        </button>
        {/each}
      </div>

    </div>

    <div class="dropdown-three__step" class:closed={!$selectedAudience || $selectedChildIndustry}>
      {#if StepTwoTitle}
        <span class="dropdown-three__heading">{StepTwoTitle}</span>
      {/if}

      {#if $selectedAudience != ''}
      <div class="dropdown-three__toggle-wrapper">
          {#each industries as industry}
          {@const IndustryData = industry.acf}
          <button transition:fade={fadeParams} class="dropdown-three__toggle" data-value={industry.industry.term_id} on:click|stopPropagation={(event) => assignIndustry(event)}>
            {#if IndustryData != null}
              <img class="dropdown-three__image" src={IndustryData.url} alt="{IndustryData.title}" />
            {/if}
            <span class="dropdown-three__first-toggle-title">{@html industry.industry.name}</span>
          </button>
          {/each}
        </div>
      {/if}

    </div>

    <div class="dropdown-three__step" class:closed={!$selectedChildIndustry || $selectedSolution}>
      {#if StepThreeTitle}
        <span class="dropdown-three__heading">{StepThreeTitle}</span>
      {/if}

    {#if $selectedChildIndustry != ''}
      {#await fetchSolutions($selectedChildIndustry, $selectedAudience) then solutions}
        <div class="dropdown-three__toggle-wrapper">
          {#each solutions as solution}
            {@const SolutionData = solution.acf}
            <button transition:fade={fadeParams} class="dropdown-three__toggle"  data-value={solution.solution.term_id} on:click|stopPropagation={(event) => assignSolution(event)}>
                {#if SolutionData != null}
                  <img class="dropdown-three__image" src={solution.acf.url ? solution.acf.url : ''} alt="{solution.acf.title ? solution.acf.title : ''}" />
                {/if}
                <span class="dropdown-three__first-toggle-title">{@html solution.solution.name}</span>
            </button>
          {/each}
        </div>
      {/await}
    {/if}
  </div>

  {#if $selectedSolution != ''}
    {#await fetchProducts($selectedSolution, $selectedAudience, $selectedChildIndustry) then products}
      <div class="dropdown-three__step">
        {#if StepFourTitle}
          <span class="dropdown-three__heading">{StepFourTitle}</span>
        {/if}
        {#if products}
          {#each products as product}
            <ProductCard {...product}></ProductCard>
          {/each}
        {/if}
      </div>
    {/await}
  {/if}

  </div>
</div>
